export enum RewardsGameEndpoints {
    IsUserAllowed = "ux-consulta-clientes-dacadoo/servicio-al-cliente/mep/v1/clientes/raspa-gana",
    GetAllGames = "miep/ux-me-ma-gestionjuegosraspaganacliente/v1/scratch",
    GetGame = "miep/ux-me-ma-gestionjuegosraspaganacliente/v1/scratch/:id",
    GameStatus = "miep/ux-me-ma-gestionjuegosraspaganacliente/v1/scratch/:id",
    StartGame = "miep/ux-me-ma-gestionjuegosraspaganacliente/v1/scratch/:id",
    AcceptLDP = "miep/ux-me-ma-gestionjuegosraspaganacliente/v1/scratch/:id",
}
